import script from "./VenueInviteDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueInviteDetail.vue?vue&type=script&setup=true&lang=js"

import "./VenueInviteDetail.vue?vue&type=style&index=0&id=c66948c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c66948c2"]])

export default __exports__